import { FormBase } from '../form';

export class FormTransition extends FormBase {
  transitions: Transition[];
}
export class Transition {
  userActionID: string;
  actionProcessOnServer: boolean;
  transitStateID: any;
  currentStateID: any;
  message: TransitionMessage;
}
export class TransitionMessage {
  messageID: string;
  options: [
    {
      option: any;
      transitUserActionID: string;
      actionProcessOnServer: boolean;
    }
  ];
}
